import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

import { Text } from '../../atoms';

type NetworkFeeFreeRibbonProps = { withPadding?: boolean };

export const NetworkFeeFreeRibbon = ({ withPadding = true }: NetworkFeeFreeRibbonProps) => {
	const { $t } = useIntl();

	return (
		<S.NetworkFeeFreeDescriptionWrapper $withPadding={withPadding}>
			<S.FeeCardLabel $withPadding={withPadding}>
				<Text variant="caption1">{$t('payments.label.feeCoverage')}</Text>
				<S.FreeLabel>
					<S.FreeLabelText variant="caption1">{$t('payments.label.free')}</S.FreeLabelText>
				</S.FreeLabel>
			</S.FeeCardLabel>
		</S.NetworkFeeFreeDescriptionWrapper>
	);
};

namespace S {
	export const NetworkFeeFreeDescriptionWrapper = styled.div<{ $withPadding: boolean }>`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
		padding: ${({ $withPadding, theme }) =>
			$withPadding ? `0 ${theme.sizing.xxsmall} ${theme.sizing.xsmall}` : '0'};
	`;

	export const FeeCardLabel = styled.div<{ $withPadding: boolean }>`
		${({ $withPadding, theme }) => $withPadding && theme.border.radius.mediumBottom};
		background-color: ${({ theme }) => theme.colors.backgrounds.info.subtle};
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: ${({ theme }) => theme.spacings.xxxsmall} ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const FreeLabel = styled.div`
		${({ theme }) => theme.border.radius.small};
		background-color: ${({ theme }) => theme.colors.backgrounds.brand.selected};
		border: ${({ theme }) => `0.7px solid ${theme.colors.borders.brand.enabled}`};
		padding: 0px ${({ theme }) => theme.spacings.xxsmall};
		border-radius: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const FreeLabelText = styled(Text)`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;
}
